module.exports = __webpack_public_path__ + "static/media/USAG Logo - White.064c9fd5.png";